export const FILL_BLANK_DOT_PITCH = 8;
export const FILL_BLANK_MIN_DOTS = 10;
export const fillBlankMinWidth = FILL_BLANK_DOT_PITCH * FILL_BLANK_MIN_DOTS;

export const fillBlankUnderlineSx = {
  borderBottom: "1px dashed",
  borderColor: "grey.400",
  minWidth: fillBlankMinWidth,
};

export const fillBlankUnderlineStyle = {
  borderBottom: "1px dashed",
  borderColor: "#bdbdbd",
  minWidth: fillBlankMinWidth,
};

export const fillBlankTextFieldSx = {
  minWidth: fillBlankMinWidth,
  "& .MuiOutlinedInput-root": {
    borderRadius: 0,
    minWidth: fillBlankMinWidth,
    "& fieldset": {
      border: "none",
      ...fillBlankUnderlineSx,
      borderRadius: 0,
      minWidth: fillBlankMinWidth,
    },
  },
};

export const fillBlankTrailingLineSx = {
  flex: "1 1 120px",
  minWidth: fillBlankMinWidth,
  minHeight: 28,
  alignSelf: "flex-end",
  ...fillBlankUnderlineSx,
};

// Sizes a blank's input/underline to the expected answer length, mirroring the
// short-answer TypeDrawInput compactCh formula (answerLength + padding, clamped).
// Student payloads never carry correct_blanks for multi-fill / fill-in-the-blank, so
// the backend ships answer_data.blank_lengths (a width hint only); fall back to the
// answer text itself on surfaces that do have it (admin review, answer key).
export function fillBlankWidthCh(question, blankIdx, answerText) {
  const hinted = question?.answer_data?.blank_lengths?.[blankIdx];
  const len = Number.isFinite(hinted) && hinted > 0
    ? hinted
    : String(Array.isArray(answerText) ? answerText.join(" ") : (answerText ?? "")).trim().length;
  if (!len) return null;
  return Math.min(Math.max(len + 6, 10), 40);
}
